module.exports = __webpack_public_path__ + "static/media/25_B.12d5a2c5.png";